export default __webpack_public_path__ + "static/media/4.56f1ce14.jpg";